import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import './EtchBlockHeaderStory.scss';
import './EtchBlockHeaderStoryReverse.scss';

const EtchBlockHeaderStory = (props) => {
  const { opts = {} } = props;
  const {
    cta,
    ctaLink,
    isEtchBlockHeaderStory,
    isEtchBlockHeaderStoryReverse,
    heading,
    id,
    listLink = [{}],
    podList = [{}],
    subHeading,
  } = opts;
  const wrapperClass = classNames({
    EtchBlockHeaderStory: isEtchBlockHeaderStory,
    EtchBlockHeaderStoryReverse: isEtchBlockHeaderStoryReverse
  });
  return (
    <div className={wrapperClass} data-module-id={id}>
      <div className={`${wrapperClass}__padding`}>
        <div className={`${wrapperClass}__copyBlockHeader`}>
          <p className={`${wrapperClass}__heading  u__large u__bold u--paddingBottom`}>
            { heading }
          </p>
          <p className={`${wrapperClass}__subHeading u__medium u--paddingBottom`}>
            { subHeading }
          </p>
          <a href={ctaLink} className="bttn bttn--primary bttn--inline">
            <span className="bttn__content">{ cta }</span>
          </a>
          <div className="u--paddingTop">
            <ul className={`${wrapperClass}__list list list--type-plain`}>
              { listLink
                && listLink.map((links) => {
                  return (
                    <li className={`${wrapperClass}__listItem list__item`}>
                      {links.link
                      && (
                        <a href={links.link} className="list__link">
                          { links.linkText }
                        </a>
                      )}
                      {!links.link
                        && <p> { links.linkText } </p>}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
        <div className={`${wrapperClass}__podContainer`}>
          { podList
            && podList.map((pod) => {
              const { podMedia = {} } = pod;
              return (
                <div className={`${wrapperClass}__pod`}>
                  <Image className={`${wrapperClass}__podImage`} src={podMedia.src} alt={podMedia.alt} />
                  <p className="u__medium u--paddingBottom">{ pod.podHeader }</p>
                  <p className="u--paddingBottom">{ pod.podSubHeader }</p>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

EtchBlockHeaderStory.propTypes = {
  opts: PropTypes.shape({
    ctaLink: PropTypes.string,
    cta: PropTypes.string,
    isEtchBlockHeaderStory: PropTypes.bool,
    heading: PropTypes.string,
    id: PropTypes.string,
    listLink: PropTypes.array,
    podList: PropTypes.array,
    subHeading: PropTypes.string,
  }).isRequired
};
EtchBlockHeaderStory.defaultProps = {
};

export default EtchBlockHeaderStory;
